<template>
  <div class="bg-bf" id="mainPage">
    <transition :name="routerTransition" mode="out-in" v-if="isLoaded">
      <div>
        <esp-header :dataPage="dataPage" :dataIris="dataIris" v-if="isLoaded" ref="espHeader"></esp-header>
        <router-view :dataPage="dataPage" :dataIris="dataIris" v-if="isLoaded"/>
        <esp-footer :dataPage="dataPage" :dataIris="dataIris" ref="espFooter" v-if="isLoaded"></esp-footer>
      </div>
    </transition>
  </div>
</template>
<script>
import Vue from 'vue'

// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();

// CONFIG
import  { themeConfig, irisConfig }  from "@/../siteConfig.js";

// IMPORT ZONES HEADER AND FOOTER
import EspHeader from "@/layouts/Header.vue"
import EspFooter from "@/layouts/Footer.vue";

export default {
  components: {
    EspHeader,
    EspFooter
  },
  data() {
    return {
      routerTransition: themeConfig.routerTransition || "none",
      everLoad:false,
      irisConfig:irisConfig,
      dataIris:{
        customizableVar:[],
        customizableVarLoaded:false,
        googleAnalyticsID:'',

        menuHeader:{
          itemsMenu:{
            children:[]
          }
        },
        menuHeaderLoaded:false,

        menuFooter:{
          itemsMenu:{
            children:[]
          }
        },
        menuFooterLoaded:false,

        pages:[],
        pagesLoaded:false,

        articles:[],
        articlesLoaded:false
      },
      dataPage:{
        customizableVar:[
          { 
            value:{
              value: "0f555d"
            }
          }
        ]
      }
    };
  },
  metaInfo() {
    return { 
        title: this.dataPage.metaTitle ? this.dataPage.metaTitle : "Véronique LESOURD - Hypnose, Coaching et Magnétisme",
        meta: [
            { name: 'description', content: this.dataPage.metaDescription ? this.dataPage.metaDescription : 'Véronique LESOURD est une praticienne en hypnose, une coach et un magnétiseur qui traite vos maux à Rouen'},
            { property: 'og:title', content: this.dataPage.metaTitle ? this.dataPage.metaTitle : "Véronique LESOURD - Hypnose, Coaching et Magnétisme"},
            { property: 'og:site_name', content: 'Véronique LESOURD'},
            { property: 'og:type', content: 'website'},    
            { name: 'robots', content: 'index,follow'} 
        ]
    }
  },
  beforeMount() {
    this.fetchData();
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      // console.log("Route from : ", from, "Route to : ", to)
      this.getDataPage()
    }
  },
  methods: {
    getCustomizableVar(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .onSnapshot(function(doc) {
          parentThis.dataIris.customizableVar = doc.data().themeColors
          parentThis.dataIris.customizableVarLoaded=true
          parentThis.dataIris.googleAnalyticsID = doc.data().googleAnalyticsID
          
        })
    },
    getMenuHeader(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('En-tête_Menu')
        .doc(this.irisConfig.menuHeader)
        .onSnapshot(function(doc) {
          parentThis.dataIris.menuHeader=doc.data()
           parentThis.dataIris.menuHeaderLoaded=true
        })
    },
    getMenuFooter(){
      this.dataIris.customizableVar=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('Pied-de-page_Menu')
        .doc(this.irisConfig.menuFooter)
        .onSnapshot(function(doc) {
          parentThis.dataIris.menuFooter=doc.data()
           parentThis.dataIris.menuFooterLoaded=true
        })
    },
    getArticles(){
      this.dataIris.articles=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('articles')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              parentThis.dataIris.articles.push(doc.data())
          })
          parentThis.dataIris.articlesLoaded=true
        })
    },
    getPages(){
      this.dataIris.pages=[]
      let parentThis = this
      db.collection("customers")
        .doc(this.irisConfig.customers)
        .collection('sites')
        .doc(this.irisConfig.sites)
        .collection('pages')
        .onSnapshot(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              parentThis.dataIris.pages.push(doc.data())
          })
          parentThis.dataIris.pagesLoaded=true
        })
    },
    getDataPage(){
      this.everLoad = true
        console.log("recherche par route",this.$route);
      if(this.$route.name=="news-view"){
        this.dataPage = this.dataIris.articles.find(article => article.route === this.$route.params.route.replace("/","")) 
        console.log("news-view", this.dataPage)
      }else if(this.$route.params.id){
        // Recherche par id
        this.dataPage = this.dataIris.pages.find(page => page.id === this.$route.params.id) 
      }else{
        // Recherche par route
        // console.log("recherche par route")
        this.dataPage = this.dataIris.pages.find(page => page.route === this.$route.params.route.replace("/","")) 
      }
    },
    fetchData() {
      this.getCustomizableVar(),
      this.getPages(),
      this.getArticles(),
      this.getMenuHeader()
      this.getMenuFooter()
    }
  },
  computed:{
    isLoaded: function () {
      if(this.dataIris.customizableVarLoaded && this.dataIris.menuHeaderLoaded && this.dataIris.articlesLoaded && this.dataIris.menuFooterLoaded && this.dataIris.pagesLoaded ){    
        if(this.everLoad==false){
          this.getDataPage()
        }    
        return true
      }else{
        return false
      }
    }
  }
};
</script>

